import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

 export const PrivateRoute = () => {
    const auth = useSelector((state: any) => state.authenticate);
    if (!auth.isLoggedIn) {
        return <Navigate to="/login" state={{ from: '/' }} replace={true} />
    }
    return <Outlet />;
}